/* eslint no-unused-vars:0 */

export const SET_GUIDE_VERSION = 'SET_GUIDE_VERSION';

/**
 * Updates the planning store section of the state tree
 * @method  planningStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */

const initialState = {
  isPlanning: false,
};

/**
 * Updates the planning store section of the state tree
 * @method  planningStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */
export default function planningStore(state = initialState, action) {
  switch (action.type) {
    case 'PLANNING_TOKEN_EXISTS':
      return {
        ...state,
        isPlanning: action.planningExists === true,
      };
    case SET_GUIDE_VERSION:
      return {
        ...state,
        guideVersion: action.guideVersion,
        funeralHomeZipcode: action.funeralHomeZipcode,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/planningStore.js